var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('IncomingSalesLeadsTable')],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }